import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import {
  SUPPORTED_LANGUAGES,
  type SupportedLanguage,
} from "../../../api/src/shared/domain/language";

import en from "../../public/locales/en/translation.json";
import fr from "../../public/locales/fr/translation.json";
import de from "../../public/locales/de/translation.json";
import es from "../../public/locales/es/translation.json";
import it from "../../public/locales/it/translation.json";
import pt from "../../public/locales/pt/translation.json";
import nl from "../../public/locales/nl/translation.json";
import ar from "../../public/locales/ar/translation.json";

export const PUBLIC_INAPP_LANGUAGES: SupportedLanguage[] = ["en", "fr"];
export const LOGIN_SIGNUP_LANGUAGES: SupportedLanguage[] = [
  "en",
  "fr",
  "de",
  "it",
  "es",
];
export const DEFAULT_LANGUAGE: SupportedLanguage = "en";

export function getLangDirection(lang: SupportedLanguage) {
  const rtlLanguages = ["ar"];
  return rtlLanguages.includes(lang) ? "rtl" : "ltr";
}

void i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    initImmediate: false,
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      es: { translation: es },
      it: { translation: it },
      pt: { translation: pt },
      nl: { translation: nl },
      ar: { translation: ar },
    },
    // Locale files store plural keys in v3 format (`_plural` for 2-form
    // languages, `_0`..`_5` for Arabic). i18next v23+ defaults to v4
    // (Intl.PluralRules: `_one`, `_other`, etc.), so plural lookups missed
    // every key and silently fell back to the singular form. Pin v3 until
    // a full key migration is done.
    compatibilityJSON: "v3",
    detection: {
      // Only use navigator (device language) for initial detection.
      // LangSync + publicAppLang handle all persistence — the detector's
      // own localStorage cache (i18nextLng) was fighting our logic and
      // surviving iOS app reinstalls via WKWebView shared data store.
      order: ["navigator"],
      caches: [],
    },
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: DEFAULT_LANGUAGE,
    returnEmptyString: false, // Treat empty translations as missing -> falls back to English
    parseMissingKeyHandler(key) {
      return key;
    },
    // load: "all",
    ns: ["translation"],
    defaultNS: "translation",
    // debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
      // force rerender when language changes + bundle resource is reloaded
      // + init completes (initialized fires after loaded — without it
      // components that gate on i18n.isInitialized never re-render)
      bindI18n: "languageChanged loaded initialized",
    },
  });

export { SUPPORTED_LANGUAGES } from "../../../api/src/shared/domain/language";
export { default } from "i18next";
